module.exports = __webpack_public_path__ + "img/play.f807b3c1.svg";